"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridPermissions = exports.CatalogPermissions = exports.ExportsPermissions = exports.OrdersPermissions = void 0;
var OrdersPermissions;
(function (OrdersPermissions) {
    OrdersPermissions["READ_ORDERS"] = "readOrders";
    OrdersPermissions["CREATE_ORDERS"] = "createOrders";
    OrdersPermissions["UPDATE_ORDERS"] = "updateOrders";
    OrdersPermissions["DELETE_ORDERS"] = "deleteOrders";
    OrdersPermissions["MANAGE_ORDER_QUANTITIES"] = "manageOrderQuantities";
    OrdersPermissions["APPROVE_ORDER"] = "approveOrder";
    OrdersPermissions["MANAGE_FULLFILLMENTS"] = "manageFullfillments";
    OrdersPermissions["READ_ORDER_COMPLETE_HISTORY"] = "readOrderCompleteHistory";
    OrdersPermissions["READ_ORDER_COMPANY_HISTORY"] = "readOrderCompanyHistory";
})(OrdersPermissions || (OrdersPermissions = {}));
exports.OrdersPermissions = OrdersPermissions;
var ExportsPermissions;
(function (ExportsPermissions) {
    ExportsPermissions["EXPORT_FLORAMEDIA"] = "exportFloramedia";
})(ExportsPermissions || (ExportsPermissions = {}));
exports.ExportsPermissions = ExportsPermissions;
var CatalogPermissions;
(function (CatalogPermissions) {
    CatalogPermissions["MANAGE_CATALOG"] = "manage_catalog";
    CatalogPermissions["EXPORT_CATALOG"] = "exportCatalog";
})(CatalogPermissions || (CatalogPermissions = {}));
exports.CatalogPermissions = CatalogPermissions;
var GridPermissions;
(function (GridPermissions) {
    GridPermissions["CONFIRM_LABEL"] = "confirmLabel";
    GridPermissions["EDIT_CONFIRMED_LABEL"] = "editConfirmedLabel";
})(GridPermissions || (GridPermissions = {}));
exports.GridPermissions = GridPermissions;
